import React, { useEffect, useState } from "react";
import Resume from "./expedition.view";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  OUT_POINT_EXPEDITION,
  STANDALONE_EXPEDITION,
} from "../../../../constants";
import { useReadBigBag } from "../hook/useReadBigBag";
import { useStandAloneProcess } from "../hook/useStandAloneProcess";

const ExpeditionResumeContainer = (props) => {
  const processType = STANDALONE_EXPEDITION.code;
  const outPoints = [OUT_POINT_EXPEDITION];
  // const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [type, setType] = useState(null);
  const [showPoint, setShowPoint] = useState(false);
  const [showResume, setShowResume] = useState(true);
  const [action, setAction] = useState("");
  const { readBigBag } = useReadBigBag(processType);
  const {
    data,
    createStandAloneProcess,
    registerBB,
    handlerRemove,
    handlerFinish,
  } = useStandAloneProcess(processType);

  const handlerReset = () => {
    setShowPoint(false);
    setShowResume(true);
    setType(null);
  };

  const handlerOpenExpedition = () => {
    setType(null);
    setShowPoint(true);
    setShowResume(false);
    setAction("open");
  };

  const handlerRegister = (actionType) => {
    setType(actionType);
    setShowPoint(true);
    setShowResume(false);
    setAction(`register${actionType}`);
  };

  return (
    <>
      {showPoint &&
        readBigBag(
          type,
          action,
          createStandAloneProcess,
          registerBB,
          handlerReset,
          outPoints
        )}
      {showResume && (
        <Resume
          data={data}
          openExpedition={handlerOpenExpedition}
          registerBB={handlerRegister}
          finish={handlerFinish}
          removeItem={handlerRemove}
        />
      )}
    </>
  );
};

ExpeditionResumeContainer.propTypes = {};

export default ExpeditionResumeContainer;
